import type { TranslationModule } from '../types';

export const caseCalendarTranslations: TranslationModule = {
  ro: {
    addToCalendar: "Adaugă în calendar",
    googleCalendar: "Google Calendar",
    microsoftOutlook: "Microsoft Outlook",
    downloadIcs: "Apple Calendar / Alte calendare (.ics)",
    downloadIcsShort: "Descarcă fișierul .ics",
    pastHearing: "Termen trecut",
    noHearingAvailable: "Niciun termen disponibil",
    checkDetailsNotice: "Verifică detaliile înainte de salvare",
    ariaButtonLabel: "Adaugă în calendar termenul pentru dosarul {numar}",
    ariaMenuLabel: "Opțiuni adăugare termen în calendar",
  },
  en: {
    addToCalendar: "Add to calendar",
    googleCalendar: "Google Calendar",
    microsoftOutlook: "Microsoft Outlook",
    downloadIcs: "Apple Calendar / Other calendars (.ics)",
    downloadIcsShort: "Download .ics file",
    pastHearing: "Past hearing",
    noHearingAvailable: "No hearing available",
    checkDetailsNotice: "Check details before saving",
    ariaButtonLabel: "Add hearing to calendar for case {numar}",
    ariaMenuLabel: "Add hearing to calendar options",
  },
  fr: {
    addToCalendar: "Ajouter au calendrier",
    googleCalendar: "Google Calendar",
    microsoftOutlook: "Microsoft Outlook",
    downloadIcs: "Apple Calendar / Autres calendriers (.ics)",
    downloadIcsShort: "Télécharger le fichier .ics",
    pastHearing: "Audience passée",
    noHearingAvailable: "Aucune audience disponible",
    checkDetailsNotice: "Vérifiez les détails avant d'enregistrer",
    ariaButtonLabel: "Ajouter l'audience au calendrier pour le dossier {numar}",
    ariaMenuLabel: "Options d'ajout au calendrier",
  },
};

export default caseCalendarTranslations;
